import { Card, CardHeader, Stack } from '@mui/material';

interface CardHeaderProps {
    title?: string;
}

interface DataGridCardProps extends React.PropsWithChildren<CardHeaderProps> {
    HeaderComponent?: () => React.ReactNode | null;
}

export function DataGridCard(props: DataGridCardProps) {
    const { title, HeaderComponent, children } = props;

    return (
        <Card>
            <CardHeader
                title={title}
                slotProps={{
                    title: {
                        variant: 'h6',
                    },
                }}
                action={HeaderComponent?.()}
            />

            <Stack>{children}</Stack>
        </Card>
    );
}
